module.exports = __webpack_public_path__ + "img/google-play-badge-us.ea90bd16.svg";